module.exports = __webpack_public_path__ + "media/images/flags/1x1/jam-d7e6039c69cab4de1976b9d6b645f1df.svg";